'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.daysAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/daysAfter.js
// module id = 664
// module chunks = 0